import { createTypedUseTranslate } from '~commons/create-typed-use-translate';
import { ThankYouWidgetTranslationKey, ThankYouSettingTranslationsKey } from '../locale-types';

export const useTranslate = createTypedUseTranslate<ThankYouWidgetTranslationKey>();
export const useSettingsTranslate = createTypedUseTranslate<ThankYouSettingTranslationsKey>();
